import React from 'react';
import { useTheme } from '@/hooks/useTheme';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-1 sm:p-1.5 md:p-2 rounded-lg transition-colors duration-200
        dark:text-gray-400 dark:hover:text-white dark:hover:bg-white/10
        text-gray-500 hover:text-gray-900 hover:bg-gray-100"
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? (
        /* Sun icon — in dark mode, click to go light */
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
          className="w-4 h-4 sm:w-[18px] sm:h-[18px] lg:w-5 lg:h-5"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      ) : (
        /* Moon icon — in light mode, click to go dark */
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
          className="w-4 h-4 sm:w-[18px] sm:h-[18px] lg:w-5 lg:h-5"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
};
